package com.ragnorak.clanybackoffice.di

import com.clany.backoffice.di.AppScope
import com.clany.backoffice.domain.usecase.DeleteAccountUseCase
import com.clany.backoffice.domain.usecase.DeleteMemberUseCase
import com.clany.backoffice.domain.usecase.DeleteUserUseCase
import com.clany.backoffice.domain.usecase.GetAccountsUseCase
import com.clany.backoffice.domain.usecase.GetDashboardMetricsUseCase
import com.clany.backoffice.domain.usecase.GetMembersUseCase
import com.clany.backoffice.domain.usecase.GetSubscriptionsUseCase
import com.clany.backoffice.domain.usecase.GetUsersUseCase
import com.clany.backoffice.domain.usecase.LoginUseCase
import com.clany.backoffice.domain.usecase.UpdateAccountUseCase
import com.clany.backoffice.domain.usecase.UpdateSubscriptionUseCase
import com.clany.backoffice.domain.usecase.UpdateUserUseCase
import com.clany.backoffice.domain.usecase.GetSubscriptionPlansUseCase
import com.clany.backoffice.domain.usecase.GetSystemConfigsUseCase
import com.clany.backoffice.domain.usecase.GetWebhookEventsUseCase
import com.clany.backoffice.domain.usecase.GetInvitationsUseCase
import com.clany.backoffice.domain.usecase.RefreshSubscriptionPlansUseCase
import com.clany.backoffice.domain.usecase.UpdateSubscriptionPlanUseCase
import com.ragnorak.clanybackoffice.ui.screens.AccountsViewModel
import com.ragnorak.clanybackoffice.ui.screens.DashboardViewModel
import com.ragnorak.clanybackoffice.ui.screens.MembersViewModel
import com.ragnorak.clanybackoffice.ui.screens.SettingsViewModel
import com.ragnorak.clanybackoffice.ui.screens.SubscriptionsViewModel
import com.ragnorak.clanybackoffice.ui.screens.UsersViewModel
import com.ragnorak.clanybackoffice.ui.screens.SubscriptionPlansViewModel
import com.ragnorak.clanybackoffice.ui.screens.MetadataViewModel
import com.ragnorak.clanybackoffice.ui.screens.WebhookEventsViewModel
import com.ragnorak.clanybackoffice.ui.screens.InvitationsViewModel
import com.ragnorak.clanybackoffice.ui.screens.NotificationsViewModel
import dev.zacsweers.metro.DependencyGraph

@DependencyGraph(AppScope::class)
interface ClientGraph : com.clany.backoffice.di.AppComponent {
    val loginUseCase: LoginUseCase
    val getUsersUseCase: GetUsersUseCase
    val updateUserUseCase: UpdateUserUseCase
    val deleteUserUseCase: DeleteUserUseCase
    val getAccountsUseCase: GetAccountsUseCase
    val updateAccountUseCase: UpdateAccountUseCase
    val deleteAccountUseCase: DeleteAccountUseCase
    val getDashboardMetricsUseCase: GetDashboardMetricsUseCase
    val getMembersUseCase: GetMembersUseCase
    val deleteMemberUseCase: DeleteMemberUseCase
    val getSubscriptionsUseCase: GetSubscriptionsUseCase
    val updateSubscriptionUseCase: UpdateSubscriptionUseCase
    val getSubscriptionPlansUseCase: GetSubscriptionPlansUseCase
    val getSystemConfigsUseCase: GetSystemConfigsUseCase
    val getWebhookEventsUseCase: GetWebhookEventsUseCase
    val getInvitationsUseCase: GetInvitationsUseCase
    val refreshSubscriptionPlansUseCase: RefreshSubscriptionPlansUseCase
    val updateSubscriptionPlanUseCase: UpdateSubscriptionPlanUseCase
    
    // ViewModels
    val usersViewModel: UsersViewModel
    val dashboardViewModel: DashboardViewModel
    val accountsViewModel: AccountsViewModel
    val membersViewModel: MembersViewModel
    val subscriptionsViewModel: SubscriptionsViewModel
    val subscriptionPlansViewModel: SubscriptionPlansViewModel
    val metadataViewModel: MetadataViewModel
    val webhookEventsViewModel: WebhookEventsViewModel
    val invitationsViewModel: InvitationsViewModel
    val settingsViewModel: SettingsViewModel
    val notificationsViewModel: NotificationsViewModel
}
